<template>
    <div class="UserSettings">
          {{this.$session.get('IberoJWT')}}
    </div>    
</template>

<script>
export default {
  name: 'Settings',
  created: function () {    
    if (!this.$session.get('IberoJWTLogin')) {
        this.$router.push('Login')
      }      
  }
}
</script>

<style scoped>
</style>